const initialState = {
  product_card: 0,
  products: [], 
  isCartOpen: false
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_CART':
     return { ...state, product_card: action.payload };

    case 'ADD_PRODUCT':
      console.log("action.payload",action.payload);
      
      return { ...state, products: [...state.products, action.payload] };

      case 'REMOVE_PRODUCT':
      const removedItem = state.products.find(
        (val) => val.product[0].unqid === action.payload
      );
      console.log("removedItem",removedItem);
      
      const countToSubtract = removedItem?.count || 1;
      return {
        ...state,
        products: state.products.filter((val) => val.product[0].unqid !== action.payload),
        product_card: Math.max(state.product_card - 1, 0),
      };

      case 'UPDATE_PRODUCT_COUNT':
        const updatedItems = state.products.map((item) => {
          if (item.product[0].unqid === action.payload.unqid) {
            const newCount =
              action.payload.type === 'inc'
                ? item.count + 1
                : Math.max(item.count - 1, 1); // Don't go below 1
            return { ...item, count: newCount };
          }
          return item;
        });

        return {
          ...state,
          products: updatedItems,
        };

           case 'TOGGLE_CART':
      return { ...state, isCartOpen: !state.isCartOpen };
    case 'CLOSE_CART':
      return { ...state, isCartOpen: false };

        case 'CLEAR_CART':
        return {
          ...state,
          product_card: 0,
          products: [],
        };


      default:
        return state;
      }
};

export default cartReducer;
